<template>
  <button
    type="button"
    class="kwadrat"
    :aria-label="`Cyfra ${number10000} na pozycji dziesiątek tysięcy. Kliknij, aby wylosować kolejną.`"
    @click="random10000"
  >
    <img
      :src="'./img/' + number10000 + '000.jpg'"
      :alt="`Skojarzenie dla cyfry ${number10000}`"
    />
  </button>
</template>

<script>
export default {
  data() {
    return {
      number10000: 7,
    };
  },
  emits: ['number10000-value'],
  methods: {
    random10000() {
      this.number10000 = Math.floor(Math.random() * 10);
      this.$emit('number10000-value', this.number10000);
    },
  },
  mounted() {
    this.$emit('number10000-value', this.number10000);
  },
};
</script>

<style scoped>
.kwadrat {
  border-top-left-radius: 30px;
  border-bottom-left-radius: 30px;
}

img {
  border-top-left-radius: 30px;
  border-bottom-left-radius: 30px;
}
</style>
